import { render } from "./FilterHeader.vue?vue&type=template&id=0888667a"
import script from "./FilterHeader.vue?vue&type=script&lang=js"
export * from "./FilterHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__